import { useState } from 'react';
// import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
// import CloseIcon from '@mui/icons-material/Close';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import {
  Box,
  Button,
  Card,
  CardContent,
  // CardMedia,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  // Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Stack } from '@mui/system';
import { post } from 'api';
import { url } from 'config/config';
import moment from 'moment';
import { enqueueSnackbar } from 'notistack';
import FilePreview from 'components/SS/filePreview';
import IconifyIcon from 'components/base/IconifyIcon';
import AddDocument from './addDocumnet';

const DocumentList = ({ docs, setDocs, fetch, customerId }) => {
  const [preview, setPreview] = useState(null);
  const [edit, setEdit] = useState(null);
  const [remark, setRemark] = useState('');
  const [oldremark, setOldRemark] = useState('');
  const [open, setOpen] = useState(false);

  const handleType = (url) => {
    if (!url) return;
    const ext = url.split('.').pop().toLowerCase();
    if (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(ext)) {
      return 'image';
    } else if (ext === 'pdf') {
      return 'padf';
    } else return 'pdf';
  };

  const handleChange = (id, field, value) => {
    setDocs((prev) => prev.map((doc) => (doc.id === id ? { ...doc, [field]: value } : doc)));
  };

  const handleSubmit = async (id) => {
    if (!edit.status) return alert('Please select Approve or Reject!');
    if (edit.status === 'reject' && !remark.trim())
      return alert('Please enter remark for rejected document!');
    const response = await post('users/document_status', {
      documentId: id,
      approve: edit.status == 'approve' ? true : false,
      remark: edit.status == 'reject' ? remark : null,
    });

    if (response.status == 200) {
      fetch();
      setEdit(null);
      setRemark('');
      setPreview(null);
      enqueueSnackbar(response.message || 'Document Status Change', {
        variant: 'success',
      });
    } else {
      enqueueSnackbar(response.message || 'Error while Updateing Document Status.', {
        variant: 'error',
      });
    }
  };

  const handleClick = (doc) => {
    setEdit(() => ({ ...doc, status: doc.approve ? 'approve' : 'reject' }));
    setPreview(`${url}${doc.url}`);
    setOldRemark(doc.rejectMessage.map((msg, index) => `${index + 1}. ${msg}`).join('\n'));
  };

  const handleImageChange = () => {
    setOpen(true);
  };

  const closeAll = () => {
    setOpen(false);
    setEdit(null);
    setPreview(null);
    fetch();
  };

  return (
    <Box sx={{ p: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h5" fontWeight={600} mb={3}>
          Customer Document Verification
        </Typography>
        <Button variant="soft" shape="square" color="neutral" sx={{ gap: 0.5, p: 1 }}>
          <IconifyIcon icon="material-symbols:add-2-rounded" />
          <Box
            component="span"
            sx={{ display: { xs: 'none', sm: 'block' } }}
            onClick={() => setOpen(!open)}
          >
            Add Document
          </Box>
        </Button>
      </Box>
      <Grid container spacing={3}>
        {docs?.length > 0 &&
          docs.map((doc) => {
            return (
              <>
                <Grid item size={{ xs: 12, sm: 4, md: 3 }} key={doc.id}>
                  <Box sx={{ position: 'relative' }}>
                    <Card
                      sx={{
                        borderRadius: 3,
                        boxShadow: 3,
                        '&:hover': { boxShadow: 6, transform: 'translateY(-2px)' },
                        transition: '0.3s',
                      }}
                      onClick={() => {
                        setPreview(`${url}${doc.url}`);
                      }}
                    >
                      <FilePreview
                        src={`${url}${doc.url}`}
                        height={180}
                        maxHeight={handleType(doc?.url) == 'padf' ? 180 : '100vh'}
                      />
                      <CardContent>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginBottom: '5px',
                          }}
                        >
                          <Typography
                            variant="subtitle1"
                            fontWeight={600}
                            mb={1}
                            textAlign="center"
                          >
                            {doc.name}
                          </Typography>
                          <Chip
                            label={
                              doc.approve == null ? 'pending' : doc.approve ? 'approve' : 'reject'
                            }
                            color={doc.approve == null ? 'info' : doc.approve ? 'success' : 'error'}
                            variant="soft"
                          />
                        </div>
                        <Divider />
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: '5px',
                          }}
                        >
                          {/* <Typography
                            variant="subtitle2"
                            fontWeight={600}
                            mb={1}
                            textAlign="center"
                          >
                            Update By
                          </Typography> */}
                          {doc.audit ? (
                            <Box>
                              <Typography variant="subtitle2">{`${doc?.audit?.userId.firstName} ${doc?.audit?.userId.lastName} - ${doc?.audit.action}`}</Typography>
                              <Typography variant="caption">
                                {moment(doc.audit.createdAt).format('DD/MM/YYYY HH:mm A')}
                              </Typography>
                            </Box>
                          ) : null}
                        </div>
                      </CardContent>
                    </Card>
                    {!doc.approve && (
                      <IconButton
                        sx={{
                          position: 'absolute',
                          top: 10,
                          right: 10,
                          background: 'white',
                          boxShadow: 2,
                          '&:hover': { background: 'white' },
                        }}
                      >
                        <ModeEditOutlineOutlinedIcon onClick={() => handleClick(doc)} />
                      </IconButton>
                    )}
                  </Box>
                </Grid>
              </>
            );
          })}
      </Grid>
      {Boolean(preview) && (
        <Dialog
          open={Boolean(preview)}
          onClose={() => {
            setPreview(null);
            setEdit(null);
            setRemark('');
          }}
          maxWidth="md"
          fullWidth
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ p: 3, pb: 2 }}
          >
            <DialogTitle sx={{ p: 0 }}>
              {edit ? 'Update Document Status' : 'Document Preview'}
            </DialogTitle>

            <IconButton
              onClick={() => {
                setPreview(null);
                setEdit(null);
                setRemark('');
              }}
            >
              <IconifyIcon icon="material-symbols:close-rounded" />
            </IconButton>
          </Stack>

          <DialogContent sx={{ p: 2 }}>
            <Box sx={{ textAlign: 'center' }}>
              <IconButton
                sx={{
                  position: 'absolute',
                  top: 70,
                  right: 25,
                  background: 'white',
                  boxShadow: 2,
                  '&:hover': { background: 'white' },
                }}
              >
                <ModeEditOutlineOutlinedIcon onClick={() => handleImageChange()} />
              </IconButton>
              <FilePreview src={preview} height={250} />
            </Box>

            {/* FORM AREA */}
          </DialogContent>
          {edit && (
            <DialogActions
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                alignItems: 'stretch',
                gap: 2, // spacing between fields
              }}
            >
              <FormControl fullWidth sx={{ mt: 4 }}>
                <RadioGroup
                  row
                  value={edit?.status}
                  onChange={(e) => setEdit((prev) => ({ ...prev, status: e.target.value }))}
                >
                  <FormControlLabel
                    value="approve"
                    control={<Radio color="success" />}
                    label="Approve"
                  />
                  <FormControlLabel
                    value="reject"
                    control={<Radio color="error" />}
                    label="Reject"
                  />
                </RadioGroup>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', lg: 'row' },
                    gap: '10px',
                  }}
                >
                  {/* edit?.status === 'reject' */}
                  {(edit?.status === 'reject' || !edit.approve) && (
                    <TextField
                      label="Enter Remark"
                      multiline
                      fullWidth
                      rows={3}
                      value={remark || ''}
                      onChange={(e) => setRemark(e.target.value)}
                      sx={{ mt: 1 }}
                    />
                  )}
                  {edit?.rejectMessage.length > 0 && (
                    <TextField
                      label="Old Remark"
                      multiline
                      fullWidth
                      rows={3}
                      disabled
                      value={oldremark || ''}
                      onChange={(e) => setOldRemark(e.target.value)}
                      sx={{ mt: 1 }}
                    />
                  )}
                </Box>
              </FormControl>

              <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                <Button
                  variant="outlined"
                  color="inherit"
                  onClick={() => handleChange(edit?.id, 'status', '')}
                >
                  Reset
                </Button>
                <Button variant="contained" onClick={() => handleSubmit(edit?._id)}>
                  Submit
                </Button>
              </Box>
            </DialogActions>
          )}
        </Dialog>
      )}
      <AddDocument
        open={open}
        setOpen={setOpen}
        fetchData={fetch}
        customerId={customerId}
        document={edit}
        closeAll={closeAll}
      />
    </Box>
  );
};

export default DocumentList;
